import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { HttpClientModule } from '@angular/common/http';


@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        HttpClientModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule
    ],
    providers: [
    ]
})

export class SharedModule{}